import React from "react";
import { ListSelect } from "../../elements/list.select";
import { withTranslation } from "react-i18next";
import { Tag } from "../../elements/tag";
export const SubscriptionPlansV4 = withTranslation()((props) => {
    // const t = props.t;
    const { selected, onChange, plans, isMainReseller } = props;
    return (React.createElement("div", null,
        React.createElement("div", { className: "flex-l-r-center m-b-4" },
            React.createElement(Tag, { className: "" }, "All prices in USD"),
            React.createElement(Tag, { className: "" }, "Plans can be modified or cancelled at any time")),
        React.createElement(ListSelect, { selected: selected, onChange: (value) => onChange(value), items: plans.map((plan, i) => ({
                value: plan.id,
                render: () => (React.createElement("div", { className: "width100 flex-line centered" },
                    React.createElement("p", { className: "small1", style: { width: "100px" } }, plan.name),
                    React.createElement("div", { className: "flex-l-r-center flex-grow" },
                        React.createElement("p", { className: "small1" }, plan.price === "0" ? "FREE" : `$${plan.price}.00 per ${plan.period}`),
                        React.createElement("p", { className: "small1" }, plan.description)))),
            })) }),
        isMainReseller && (React.createElement("div", { className: "text-center m-t-4" },
            React.createElement("p", { className: "font-semi-bold" }, "Choose the yearly plan and get 2 months free")))));
});
//# sourceMappingURL=index.js.map